import { useEffect } from 'react';
import { LoadingStatuses } from 'core/common/entities';
import { useServices } from 'core/common/hooks';
import { useSystem } from 'core/common/store/hooks';
import { useUserLocation } from 'core/user/hooks';

const resolvedLocationStatuses = new Set([LoadingStatuses.FULFILLED, LoadingStatuses.FAILED]);

export const useTrackFunnelInfo = () => {
  const { platform } = useSystem();
  const { country, loadingStatus } = useUserLocation();
  const { snitcherService, appEnvironment } = useServices();

  const isLocationResolved = resolvedLocationStatuses.has(loadingStatus);

  useEffect(() => {
    if (!isLocationResolved) return;

    snitcherService.trackFunnelInfo({
      platform,
      country,
      language: appEnvironment.getDeviceLanguage(),
    });
  }, [snitcherService, appEnvironment, platform, country, isLocationResolved]);
};
